import * as React from 'react';
import cn from 'clsx';
import * as styles from './styles.css';

export interface ICollapseProps {
  isOpen: boolean;
  children: React.ReactNode;
}

export class Collapse extends React.Component<ICollapseProps, {}> {
  private container: React.RefObject<HTMLDivElement> = React.createRef();

  public componentDidMount() {
    this.setHeight();
  }

  public componentDidUpdate() {
    this.setHeight();
  }

  public render() {
    const { children, isOpen } = this.props;

    return (
      <div ref={this.container} className={cn(styles['container'], isOpen && styles['open'])}>
        <div className={styles['filler']} />
        {children}
      </div>
    );
  }

  private setHeight = () => {
    const { current } = this.container;
    const { isOpen } = this.props;

    if (current) {
      current.style.maxHeight = `${isOpen ? current.scrollHeight : 0}px`;
    }
  };
}
